import '../scss/app.scss';

require('./basics.js');
require('./auto-hide-header.js');


// WEBPACK FOOTER //
// ./_assets/js/app.js